/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const LocationSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20.455 2.12c.918-.413 1.86.53 1.444 1.447l-8.048 17.77c-.486 1.073-2.092.723-2.088-.455l.03-8.171a.486.486 0 0 0-.486-.488H3.094c-1.177 0-1.522-1.606-.448-2.089l17.81-8.014Z" /></svg>);
const LocationSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={LocationSolidBase} {...rest} ref={ref} />);
export default LocationSolid;